import styled from 'styled-components';
import { Select, Button } from 'junto-ui';
import { colors, fonts, grid } from '_/styles';
import { tokens } from '@plataforma/components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.p`
  text-align: center;
  color: ${colors.textMain};
  font-weight: ${tokens.font.weight.semibold};
  font-size: ${fonts.size.medium};
  margin-bottom: ${grid.medium};
`;

export const UserSelect = styled(Select)`
  width: 100%;
  text-align: left;
`;

export const ActionButton = styled(Button)`
  width: 100%;
  margin-top: ${grid.large};
  font-family: ${tokens.font.family.metropolis};
  font-weight: ${tokens.font.weight.semibold};
`;
